import { Component, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MainLayout } from '../../layouts/main-layout';
import { MarginWrapper } from '../../layouts/margin-wrapper';
import { ProductsPage } from '../../components/shop/products-page/products-page.component';

@Component({
  selector: 'allas-products',
  imports: [MainLayout, MarginWrapper, ProductsPage],
  template: `<allas-main-layout>
    <allas-margin-wrapper>
      <!-- Titulo Principal oculto pero indexable -->
      <h1 class="absolute left-[-9999px]">
        Repuestos para carro en Honduras | Allas Repuestos
      </h1>
      <allas-products-page />
    </allas-margin-wrapper>
  </allas-main-layout>`,
})
export class Products {
  private titleService = inject(Title);
  private metaService = inject(Meta);

  constructor() {
    this.setMetadata();
  }

  private setMetadata() {
    this.titleService.setTitle(
      'Productos - Repuestos Automotrices | Allas Repuestos'
    );

    this.metaService.updateTag({
      name: 'description',
      content:
        'Encuentra los mejores repuestos automotrices para tu vehículo. Amplio catálogo de productos de calidad, marcas reconocidas y los mejores precios en Honduras.',
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Productos - Repuestos Automotrices | Allas Repuestos',
    });

    this.metaService.updateTag({
      property: 'og:description',
      content:
        'Encuentra los mejores repuestos automotrices para tu vehículo. Amplio catálogo de productos de calidad, marcas reconocidas y los mejores precios en Honduras.',
    });

    this.metaService.updateTag({
      property: 'og:type',
      content: 'website',
    });

    this.metaService.updateTag({
      property: 'og:image',
      content: 'https://www.allasrepuestos.com/logos/isotipo.webp',
    });

    this.metaService.updateTag({
      property: 'og:image:alt',
      content: 'Logo de Allas Repuestos',
    });

    this.metaService.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });

    this.metaService.updateTag({
      name: 'twitter:title',
      content: 'Productos - Repuestos Automotrices | Allas Repuestos',
    });

    this.metaService.updateTag({
      name: 'twitter:description',
      content:
        'Encuentra los mejores repuestos automotrices para tu vehículo. Amplio catálogo de productos de calidad, marcas reconocidas y los mejores precios en Honduras.',
    });

    this.metaService.updateTag({
      name: 'keywords',
      content:
        'repuestos automotrices, repuestos de autos, autopartes, productos automotrices, tienda de repuestos, Honduras, repuestos originales',
    });
  }
}
